import { render, staticRenderFns } from "./markdown-edit.vue?vue&type=template&id=03577b52"
import script from "./markdown-edit.vue?vue&type=script&lang=js"
export * from "./markdown-edit.vue?vue&type=script&lang=js"
import style0 from "./markdown-edit.vue?vue&type=style&index=0&id=03577b52&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/graphileon/graphileon/release/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('03577b52')) {
      api.createRecord('03577b52', component.options)
    } else {
      api.reload('03577b52', component.options)
    }
    module.hot.accept("./markdown-edit.vue?vue&type=template&id=03577b52", function () {
      api.rerender('03577b52', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/renderers/markdown-edit-view-renderer/markdown-edit.vue"
export default component.exports